export const environment = {
  apiUrl: 'https://swd-api-dev.azure.chevron.com/api',

  envName: 'dev',
  production: false,
  authority: 'https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26/v2.0',
  clientId: 'a1298825-2acf-4a5d-ac05-e23f5913dfe7',
  redirectUri: `${location.protocol}//${location.hostname}${location.port && ':' + location.port}/`,
  audience: 'https://swd-test.azure.chevron.com',
  knownAuthorities: ['https://login.microsoftonline.com', 'https://sts.windows.net'],
  appInsightsInstrumentationKey: '0f1feed3-f213-49db-bdde-de643de1af64',
};
